module.exports = __webpack_public_path__ + "static/media/dinosaur(10).65d30e0d.PNG";